module.exports = __webpack_public_path__ + "img/intro-st-only.cb5256ee.png";